import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user:        null,
      accessToken: null,
      isLoading:   false,
      workerName:  null, // cached once per session; null = not yet fetched

      setAuth: (user, accessToken) => set({ user, accessToken }),
      setAccessToken: (token)      => set({ accessToken: token }),
      setUser: (user)              => set({ user }),
      setWorkerName: (name)        => set({ workerName: name }),

      logout: () => set({ user: null, accessToken: null, workerName: null }),

      isAuthenticated: () => !!get().accessToken,
      isWorker:        () => get().user?.role === 'worker',
      isEmployer:      () => get().user?.role === 'employer',
      isAdmin:         () => ['admin', 'superadmin'].includes(get().user?.role),
    }),
    {
      name:    'nh-auth',
      partialize: (state) => ({ user: state.user }), // workerName is intentionally not persisted
    }
  )
);
